// extracted by mini-css-extract-plugin
export default {"EditUser__Form":"EditUser_EditUser__Form__cGhCd","EditUser__Form__Field":"EditUser_EditUser__Form__Field__IM-bJ"};